import { render, staticRenderFns } from "./EditPriceListDialog.vue?vue&type=template&id=031bb9e6&"
import script from "./EditPriceListDialog.vue?vue&type=script&lang=js&"
export * from "./EditPriceListDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditPriceListDialog.vue?vue&type=style&index=0&id=031bb9e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports